import { render, staticRenderFns } from "./addDeviceCheckup.vue?vue&type=template&id=044ca22c&scoped=true&"
import script from "./addDeviceCheckup.vue?vue&type=script&lang=js&"
export * from "./addDeviceCheckup.vue?vue&type=script&lang=js&"
import style0 from "./addDeviceCheckup.vue?vue&type=style&index=0&id=044ca22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ca22c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VDivider,VForm,VRow,VSimpleTable})
